import * as React from 'react';
import { ErrorState } from '@leagueplatform/web-common-components';
import { useIntl } from '@leagueplatform/locales';
import { Box } from '@leagueplatform/genesis-core';

function ErrorPage() {
  const { formatMessage } = useIntl();

  return (
    <Box
      css={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ErrorState
        headingString={formatMessage({ id: 'STR_SORRY_WE_CANT_FIND_PAGE' })}
        error={null}
      />
    </Box>
  );
}

export default ErrorPage;
